<header class="topbar">
  <nav class="navbar top-navbar navbar-expand">
    <div class="">
      <a class="navbar-brand" routerLink="/sign-in">
        <div class="navbar-brand-wrap row">
          <div
            class="resp-img-container d-block d-sm-none my-auto topbar-icon mr-3"
          >
            <img
              class="logo-image"
              src="./assets/images/gallery/portal-logo.png"
              alt="homepage"
            />
          </div>
          <div class="resp-img-container my-auto d-none d-sm-block">
            <img
              class="logo-text-image"
              src="./assets/images/gallery/portal-ext-logo.png"
              alt="homepage"
              height="100"
            />
          </div>
        </div>
      </a>
    </div>
    <div class="navbar-collapse">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item dropdown row">
          <a
            routerLink="/sign-up"
            class="register dropdown-item flat-button pointer p-0 my-auto"
          >
            {{ 'HEADER.SIGN-UP' | transloco }}
          </a>
        </li>
        <li class="nav-item dropdown mx-2" style="font-size: 30px">
          <label class="separation"> | </label>
        </li>
        <li class="nav-item language flat-button row">
          <div class="my-auto">
            <a (click)="changeLanguage('en')" class="change-language pointer"
              >EN
            </a>
            <span class="cursor separation">|</span>
            <a (click)="changeLanguage('es')" class="change-language pointer">
              ES</a
            >
          </div>
        </li>
      </ul>
    </div>
  </nav>
</header>

<div class="restore-password-container">
  <img src="../../assets/images/images/restore-password-illustration-1.svg" />
  <div class="restore-password-card">
    <div class="restore-password-content">
      <form
        ngNativeValidate
        #f="ngForm"
        class="form-restore-password"
        (ngSubmit)="recoverPassword(f)"
      >
        <h3 class="box-title cursor general-title m-b-20">
          {{
            isEmailSent
              ? ('RESTORE-PASSWORD.CONFIRM-EMAIL' | transloco)
              : ('RESTORE-PASSWORD.FORGOT-PASSWORD' | transloco)
          }}
        </h3>
        <p class="paragraph cursor">
          {{
            isEmailSent
              ? ('RESTORE-PASSWORD.CONFIRM-EMAIL-PARAGRAPH' | transloco)
              : ('RESTORE-PASSWORD.FORGOT-PASSWORD-PARAGRAPH' | transloco)
          }}
        </p>
        <div class="form-group">
          <input
            [ngModel]="userEmail"
            [ngClass]="{
              incorrect: isIncorrect,
            }"
            name="userEmail"
            class="form-control"
            type="email"
            required
            placeholder="{{ 'RESTORE-PASSWORD.PLACEHOLDER' | transloco }}"
          />
          @if (isIncorrect) {
            <span class="incorrect-email">{{
              'RESTORE-PASSWORD.INCORRECT-EMAIL' | transloco
            }}</span>
          }
        </div>
        @if (isEmailSent) {
          <p class="paragraph cursor">
            {{ 'RESTORE-PASSWORD.RESEND-EMAIL-PARAGRAPH' | transloco }}
          </p>
        }
        <div class="form-group button-container text-center p-b-10">
          <button
            [disabled]="isLoading || f.invalid || !f.controls.userEmail?.valid"
            class="submit-button btn btn-lg btn-block call-to-action btn-rounded btn-cards"
            type="submit"
          >
            <div class="submit-button-content">
              @if (isLoading) {
                <mat-spinner diameter="30"></mat-spinner>
              }
              @if (isLoading) {
                {{ 'RESTORE-PASSWORD.LOADING' | transloco }}
              }
              @if (!isLoading && isEmailSent) {
                {{ 'RESTORE-PASSWORD.RESEND-EMAIL' | transloco }}
              }
              @if (!isLoading && !isEmailSent) {
                {{ 'RESTORE-PASSWORD.SEND-EMAIL' | transloco }}
              }
            </div>
          </button>
        </div>
      </form>
    </div>
  </div>
  <img src="../../assets/images/images/restore-password-illustration-2.svg" />
</div>
